export const B2C_LOOKUP = {
  RoleGroup: {
    B2C: 'BU',
  },
  STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
    DISABLED: 3,
  },
  ENQUIRY: {
    GEN: 'GeneralEnquiry',
  },
  Travellers: [
    { label: 'Adult', control: 'adult' },
    { label: 'Child', otherlabel: '(age 2y-12y)', control: 'child' },
    { label: 'Infant', otherlabel: '(age under 2y)', control: 'infant' },
  ],
  TripType: {
    Flight: [
      { label: 'Round Trip', value: 'RoundTrip' },
      { label: 'One Way', value: 'OneWay' },
      { label: 'Multi Segment', value: 'MultiCity' },
    ],
  },
  SeatClass: [
    { label: 'Economy Class', value: 'Echo' },
    { label: 'Business Class', value: 'Business' },
    { label: 'First Class', value: 'First' },
    { label: 'Premium Economy', value: 'EchoPremium' },
  ],
  PaymentCards: [
    { type: 'Visa', images: 'assets/images/visa.png' },
    { type: 'Mastercard', images: 'assets/images/master-card.png' },
    { type: 'American Express', images: 'assets/images/american-express.png' },
    { type: 'Diners Club', images: 'assets/images/diners-club.png' },
    { type: 'Maestro', images: 'assets/images/maestro.png' },
    { type: 'JCB', images: 'assets/images/jcb.png' },
    { type: 'Discover', images: 'assets/images/discover.png' },
    { type: 'UnionPay', images: 'assets/images/unionpay.png' },
    { type: 'Mir', images: 'assets/images/mir.png' },
    { type: 'Elo', images: 'assets/images/elo.png' }
  ],
  Loading_Spinner_Config: [
    {
      module: 'FT',
      text:
        'We are fetching best flights information based on the Route selection',
    },
  ],
  INVALID_SEARCH: [
    { psgr: 'INF', message: 'Infant count cannot be greater than adult count' },
  ],
  REQUIRED_BOOKING_FORM_LIST: [
    'PassportNumber',
    'PassportExpiryDate',
    'Nationality',
  ],
};

export const prefferedContactTypes = [
  { label: 'Email', value: 'email' },
  { label: 'Phone Call', value: 'phone' }
]

export const paymentTypes = [
  { label: 'Credit Card', value: 'cc' },
  { label: 'Paypal', value: 'pp' },
  { label: 'Visa Checkout', value: 'vc' },
];


export const paymentCurrencyOptions = [
  { label: 'Indian Currency', value: 'IN', freeText: "It will be used Indian Payment Gateway", currency: "INR" },
  { label: 'US Currency', value: 'US', freeText: "It will be used USA Payment Gateway", currency: "USD" }
];


export const CarDates = [
  { label: '12:00 AM', value: '0000' },
  { label: '12:15 AM', value: '0015' },
  { label: '12:30 AM', value: '0030' },
  { label: '12:45 AM', value: '0045' },
  { label: '01:00 AM', value: '0100' },
  { label: '01:15 AM', value: '0115' },
  { label: '01:30 AM', value: '0130' },
  { label: '01:45 AM', value: '0145' },
  { label: '02:00 AM', value: '0200' },
  { label: '02:15 AM', value: '0215' },
  { label: '02:30 AM', value: '0230' },
  { label: '02:45 AM', value: '0245' },
  { label: '03:00 AM', value: '0300' },
  { label: '03:15 AM', value: '0315' },
  { label: '03:30 AM', value: '0330' },
  { label: '03:45 AM', value: '0345' },
  { label: '04:00 AM', value: '0400' },
  { label: '04:15 AM', value: '0415' },
  { label: '04:30 AM', value: '0430' },
  { label: '04:45 AM', value: '0445' },
  { label: '05:00 AM', value: '0500' },
  { label: '05:15 AM', value: '0515' },
  { label: '05:30 AM', value: '0530' },
  { label: '05:45 AM', value: '0545' },
  { label: '06:00 AM', value: '0600' },
  { label: '06:15 AM', value: '0615' },
  { label: '06:30 AM', value: '0630' },
  { label: '06:45 AM', value: '0645' },
  { label: '07:00 AM', value: '0700' },
  { label: '07:15 AM', value: '0715' },
  { label: '07:30 AM', value: '0730' },
  { label: '07:45 AM', value: '0745' },
  { label: '08:00 AM', value: '0800' },
  { label: '08:15 AM', value: '0815' },
  { label: '08:30 AM', value: '0830' },
  { label: '08:45 AM', value: '0845' },
  { label: '09:00 AM', value: '0900' },
  { label: '09:15 AM', value: '0915' },
  { label: '09:30 AM', value: '0930' },
  { label: '09:45 AM', value: '0945' },
  { label: '10:00 AM', value: '1000' },
  { label: '10:15 AM', value: '1015' },
  { label: '10:30 AM', value: '1030' },
  { label: '10:45 AM', value: '1045' },
  { label: '11:00 AM', value: '1100' },
  { label: '11:15 AM', value: '1115' },
  { label: '11:30 AM', value: '1130' },
  { label: '11:45 AM', value: '1145' },
  { label: '12:00 PM', value: '1200' },
  { label: '12:15 PM', value: '1215' },
  { label: '12:30 PM', value: '1230' },
  { label: '12:45 PM', value: '1245' },
  { label: '01:00 PM', value: '13O0' },
  { label: '01:15 PM', value: '1315' },
  { label: '01:30 PM', value: '1330' },
  { label: '01:45 PM', value: '1345' },
  { label: '02:00 PM', value: '1400' },
  { label: '02:15 PM', value: '1415' },
  { label: '02:30 PM', value: '1430' },
  { label: '02:45 PM', value: '1445' },
  { label: '03:00 PM', value: '1500' },
  { label: '03:15 PM', value: '1515' },
  { label: '03:30 PM', value: '1530' },
  { label: '03:45 PM', value: '1545' },
  { label: '04:00 PM', value: '1600' },
  { label: '04:15 PM', value: '1615' },
  { label: '04:30 PM', value: '1630' },
  { label: '04:45 PM', value: '1645' },
  { label: '05:00 PM', value: '1700' },
  { label: '05:15 PM', value: '1715' },
  { label: '05:30 PM', value: '1730' },
  { label: '05:45 PM', value: '1745' },
  { label: '06:00 PM', value: '1800' },
  { label: '06:15 PM', value: '1815' },
  { label: '06:30 PM', value: '1830' },
  { label: '06:45 PM', value: '1845' },
  { label: '07:00 PM', value: '1900' },
  { label: '07:15 PM', value: '1915' },
  { label: '07:30 PM', value: '1930' },
  { label: '07:45 PM', value: '1945' },
  { label: '08:00 PM', value: '2000' },
  { label: '08:15 PM', value: '2015' },
  { label: '08:30 PM', value: '2030' },
  { label: '08:45 PM', value: '2045' },
  { label: '09:00 PM', value: '2100' },
  { label: '09:15 PM', value: '2115' },
  { label: '09:30 PM', value: '2130' },
  { label: '09:45 PM', value: '2145' },
  { label: '10:00 PM', value: '2200' },
  { label: '10:15 PM', value: '2215' },
  { label: '10:30 PM', value: '2230' },
  { label: '10:45 PM', value: '2245' },
  { label: '11:00 PM', value: '2300' },
  { label: '11:15 PM', value: '2315' },
  { label: '11:30 PM', value: '2330' },
  { label: '11:45 PM', value: '2345' },
];

export const FLIGHT_SEARCH_ERROR_MSG = [
  'NO FARE FOUND FOR REQUESTED ITINERARY',
  'Bad value (coded) - arrivalLocalization',
];

export const BOOKING_ERROR_MSG = {
  FLIGHT: [
    {
      code: 'AVAIL_CHK_FT',
      ytb_message:
        'Something went wrong while checking your flight seat availability, please try other flights while YTB team looks for the cause or you can contact us by clicking on Contact Us below',
      supplier_message: [],
    },
    {
      code: 'BOOK_ERR_FT',
      ytb_message:
        'Something went wrong while booking your flight,please try other flights while YTB team looks for{ the cause or you can contact us by clicking on Contact Us below',
      supplier_message: [
        {
          code: 'UA ETKT: DUPLICATE NAME,PLEASE UPDATE',
          ytb_message:
            'It seems that a duplicate booking has been occurred in our system, please try booking for other flights',
        },
        {
          code: 'TTP/TTM NOT AUTHORISED FOR LCC',
          ytb_message:
            'It seems that a low cost carrier has rejected your booking due to some restrictions,please try other flights',
        },
      ],
    },
  ],

  HOTEL: [
    {
      code: 'BOOK_ERR_HL',
      ytb_message:
        'Something went wrong while booking your Hotel,please try other Hotels while YTB team looks for the cause or you can contact us by clicking on Contact Us below',
    },
  ],

  CAR: [
    {
      code: 'BK_Failed',
      ytb_message:
        'We are having some technical issue to process your Booking. Please try again.',
    },
    {
      code: 'Ex_BOOK',
      ytb_message:
        'We are having some technical issue to process your Booking. Please try again.',
    },
    {
      code: 'CR_NTAVBL',
      ytb_message:
        'Unable to Fetch this Car Details at this moment.Please try again',
    },
  ],

  ACTIVITIES: [
    {
      code: 'BOOK_ERR_SS',
      ytb_message:
        'Something went wrong while booking your Tour,please try other Tours while YTB team looks for the cause or you can contact us by clicking on Contact Us below',
    },
  ],
};

export const ActivityTermsAndConditions = [
  { code: 1, description: "Products in this category are cancellable up to 24 hours before the travel date (local supplier time) for a full refund. However, a 100% cancellation penalty applies for cancellations submitted less than 24 hours before the start time. Most products (about 85%) fall into this category", category: " Standard cancellation policy" },
  { code: 2, description: "The refund amount for products in this category varies depending on how long before its start time the product is cancelled. Many products on a custom policy are multi-day tours, which require more sophisticated planning on the supplier’s end. Only a small number of products (around 5%) fall into this category.", category: " Custom cancellation policy" },
  { code: 3, description: "Products in this category cannot be cancelled or amended without incurring a 100% penalty; i.e., the refund amount will be zero. Around 10% of products fall into this category.", category: " All sales final (100% cancellation penalty / no refund offered)" }
];



export const Wheel_Chair_Types = [
  { code: 'WCHC', description: 'Wheelchair - all the way to seat' },
  { code: 'WCHR', description: 'Wheelchair - for ramp ' },
  { code: 'WCHS', description: 'Wheelchair - up and down steps' },
  { code: 'WCOB', description: 'Wheelchair - on board' },
];
export const Wheel_Chair_Type_Code = [
  { code: 'WCMP', description: 'Wheelchair - manual power (US carriers only)' },
  { code: 'WCBD', description: 'Wheelchair - dry cell battery' },
  { code: 'WCBW', description: 'Wheelchair - wet cell battery' },
];
export const GeoPluginKey = '4ea0bbc863bcb195';

export const commonError = 'Some Inernal Server Error Occurs. Please try again';
export const seatTypes = [
  { code: 'L', value: 'Leg Space Seat' },
  { code: 'CH', value: 'Chargeable Seats' },
  { code: 'LS', value: 'Left side of Aircraft' },
  { code: 'O', value: 'Preferential Seat' },
  { code: 'X', value: 'No Facility Seat' },
  { code: 'MA', value: 'Medically OK to Travel' },
  { code: '1D', value: 'Restricted Recline Seat' },
  { code: 'E', value: 'Exit Row Seat' },
];

export const addOns = [
  {
    suppliercode: 'TF',
    addOnLabels: [
      { supplierLabel: 'extras', label: 'Equipments' },
      { supplierLabel: 'luggage', label: 'Luggage' },
      { supplierLabel: 'outwardLuggage', label: 'Luggage' },
      { supplierLabel: 'returnLuggage', label: 'Luggage' },
      { supplierLabel: 'ancillaryOptions', label: 'Cabin Luggage' },
      { supplierLabel: 'speedyBoarding', label: 'Speedy Boarding' },
    ],
  },
];

export const seat_images = [
  {
    class: 'Economy',
    seat_icons: [
      { id: 1, value: 'assets/images/blueseat1.png' },
      { id: 2, value: 'assets/images/blueseat2.png' },
      { id: 3, value: 'assets/images/blueseat3.png' },
      { id: 4, value: 'assets/images/blueseat4.png' },
      { id: 5, value: 'assets/images/blueseat5.png' },
      { id: 6, value: 'assets/images/blueseat6.png' },
      { id: 7, value: 'assets/images/blueseat7.png' },
      { id: 8, value: 'assets/images/blueseat8.png' },
    ],
  },
  {
    class: 'Echo Premium',
    seat_icons: [
      { id: 1, value: 'assets/images/blueseat1.png' },
      { id: 2, value: 'assets/images/blueseat2.png' },
      { id: 3, value: 'assets/images/blueseat3.png' },
      { id: 4, value: 'assets/images/blueseat4.png' },
      { id: 5, value: 'assets/images/blueseat5.png' },
      { id: 6, value: 'assets/images/blueseat6.png' },
      { id: 7, value: 'assets/images/blueseat7.png' },
      { id: 8, value: 'assets/images/blueseat8.png' },
    ],
  },
  {
    class: 'First Class',
    seat_icons: [
      { id: 1, value: 'assets/images/business_blue_seats.png' },
      { id: 2, value: 'assets/images/business_blue_seats1.png' },
      { id: 3, value: 'assets/images/business_blue_seats2.png' },
      { id: 4, value: 'assets/images/business_blue_seats3.png' },
      { id: 5, value: 'assets/images/business_blue_seats4.png' },
      { id: 6, value: 'assets/images/business_blue_seats5.png' },
      { id: 7, value: 'assets/images/business_blue_seats6.png' },
      { id: 8, value: 'assets/images/business_blue_seats7.png' },
    ],
  },
  {
    class: 'Business Class',
    seat_icons: [
      { id: 1, value: 'assets/images/business_blue_seats.png' },
      { id: 2, value: 'assets/images/business_blue_seats1.png' },
      { id: 3, value: 'assets/images/business_blue_seats2.png' },
      { id: 4, value: 'assets/images/business_blue_seats3.png' },
      { id: 5, value: 'assets/images/business_blue_seats4.png' },
      { id: 6, value: 'assets/images/business_blue_seats5.png' },
      { id: 7, value: 'assets/images/business_blue_seats6.png' },
      { id: 8, value: 'assets/images/business_blue_seats7.png' },
    ],
  },
  {
    class: 'Echo Standard',
    seat_icons: [
      { id: 1, value: 'assets/images/business_blue_seats.png' },
      { id: 2, value: 'assets/images/business_blue_seats1.png' },
      { id: 3, value: 'assets/images/business_blue_seats2.png' },
      { id: 4, value: 'assets/images/business_blue_seats3.png' },
      { id: 5, value: 'assets/images/business_blue_seats4.png' },
      { id: 6, value: 'assets/images/business_blue_seats5.png' },
      { id: 7, value: 'assets/images/business_blue_seats6.png' },
      { id: 8, value: 'assets/images/business_blue_seats7.png' },
    ],
  },
  {
    class: 'Premium First',
    seat_icons: [
      { id: 1, value: 'assets/images/business_blue_seats.png' },
      { id: 2, value: 'assets/images/business_blue_seats1.png' },
      { id: 3, value: 'assets/images/business_blue_seats2.png' },
      { id: 4, value: 'assets/images/business_blue_seats3.png' },
      { id: 5, value: 'assets/images/business_blue_seats4.png' },
      { id: 6, value: 'assets/images/business_blue_seats5.png' },
      { id: 7, value: 'assets/images/business_blue_seats6.png' },
      { id: 8, value: 'assets/images/business_blue_seats7.png' },
    ],
  },
  {
    class: 'Premium Business',
    seat_icons: [
      { id: 1, value: 'assets/images/business_blue_seats.png' },
      { id: 2, value: 'assets/images/business_blue_seats1.png' },
      { id: 3, value: 'assets/images/business_blue_seats2.png' },
      { id: 4, value: 'assets/images/business_blue_seats3.png' },
      { id: 5, value: 'assets/images/business_blue_seats4.png' },
      { id: 6, value: 'assets/images/business_blue_seats5.png' },
      { id: 7, value: 'assets/images/business_blue_seats6.png' },
      { id: 8, value: 'assets/images/business_blue_seats7.png' },
    ],
  },
  {
    class: 'Premium Business',
    seat_icons: [
      { id: 1, value: 'assets/images/business_blue_seats.png' },
      { id: 2, value: 'assets/images/business_blue_seats1.png' },
      { id: 3, value: 'assets/images/business_blue_seats2.png' },
      { id: 4, value: 'assets/images/business_blue_seats3.png' },
      { id: 5, value: 'assets/images/business_blue_seats4.png' },
      { id: 6, value: 'assets/images/business_blue_seats5.png' },
      { id: 7, value: 'assets/images/business_blue_seats6.png' },
      { id: 8, value: 'assets/images/business_blue_seats7.png' },
    ],
  },
];

export const Hotel_Error_Msg = {
  HotelDetails: [
    {
      code: 'Hotel_Info_Err',
      message:
        'we are facing some issues while pulling Hotel Information please try again after sometime',
    },
    {
      code: 'Rooms_Info_Err',
      message:
        'we are facing some issues while pulling Rooms Information for Specified Hotel Please try with alternate Hotel',
    },
    {
      code: 'Req_Info_Err',
      message:
        'we are facing some issues while fetching information for a given request',
    },
    {
      code: 'Pre_Book_Err',
      message:
        'we are facing some issues while checking the availability for selected room',
    },
    {
      code: 'Rooms_Aval',
      message:
        'No Rooms are available for selected hotel please try some alternative',
    },
  ],
  HotelBookDtls: [
    {
      code: 'Book_Err_Info',
      message:
        'we are facing some issues while processing your booking request please try with alternate hotel',
    },
  ],
};

export const Hotel_Default_ErrMsg =
  'We are facing some issues while fetching the details please try again affter some time';





export const Status = [
  {
    Name: 'Active', Status_Code: "1"
  },
  {
    Name: 'InActive', Status_Code: "2"
  },
  {
    Name: 'Max Limit Exceed', Status_Code: "15"
  },
  {
    Name: 'Expired', Status_Code: "14"
  }
];



export const Markup_Value = [
  {
    Name: 'Percentage', Status_Code: "3"
  },
  {
    Name: 'Flat', Status_Code: "4"
  },
  {
    Name: 'Condition', Status_Code: "16"
  }
];


export const Module_Codes = [
  { module: "flight", code: "FT" },
  { module: "activity", code: "SS" },
  { module: "car", code: "CR" },
  { module: "hotel", code: "HL" }
];

export const SEG_STATUS = [
  { status: 'Confirmed', badge: 'badge badge-success mr-2' },
  { status: 'Rejected', badge: 'badge badge-danger' },
  { status: 'Deleted', badge: 'badge badge-danger' },
  { status: 'Does not Operate', badge: 'badge badge-danger' },
  { status: 'Waiting to confirm', badge: 'badge badge-warning' },
  { status: 'UNABLE FLIGHT CLOSED', badge: 'badge badge-danger' }
];

export const authObj = {
  'app-Id': '61dbd00c-fe55-45be-9faf-df6e04093a69',
  'secretKey': 'b02184cc9713ec2ee64e2d041e42bbe4db2529e1d6b10f35e1eb1a7ea045f03f'
};

export const FT_SUPPLIER = ['AS', 'SB'];
export const Social_Providers = [
  { provider: 'facebook', value: "875796586308287" },
  { provider: 'google', value: "833958147354-1g24dgpv80qht78df9s2oqthdjhqafqi.apps.googleusercontent.com" }
]

export const flexibleDates = [
  { code: '', value: 'Fixed Days', origional: 0 },
  { code: 'C', value: 'Requested Date +/- 1 Days Max', origional: 1 },
  { code: 'P', value: 'Requested Date + 2 Days Max', origional: 2 },
  { code: 'M', value: 'Requested Date - 2 Days Max', origional: 2 },
  { code: 'PP', value: 'Requested Date + 7 Days Max', origional: 7 },
  { code: 'MM', value: 'Requested Date - 7 Days Max', origional: 7 }
];

 